import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import type { FilterCardType } from 'favorites/types';

type Filter = {
  type: FilterCardType;
  label: string;
};

export const FILTER_TYPE_ALL = 'all';

export const CARD_TYPE_FILTERS: Array<Filter> = [{ type: FILTER_TYPE_ALL, label: 'All' }];

export interface Data {
  name: string;
  url: string;
}

export const CARD_TYPE_DATA: { [key: string]: Data } = {
  [FILTER_TYPE_ALL]: { name: 'Invites and paper', url: '/wedding-planning/save-the-date/shop' },
  [CARD_TYPE_MAP.std]: { name: 'Save the Dates', url: '/wedding-planning/save-the-date/shop' },
  [CARD_TYPE_MAP.dstd]: {
    name: 'Digital Save the Dates',
    url: '/wedding-planning/digital/save-the-date/shop',
  },
  [CARD_TYPE_MAP.invitation]: { name: 'Invitations', url: '/wedding-planning/invitations/shop' },
  [CARD_TYPE_MAP.ctd]: { name: 'Change the dates', url: '/wedding-planning/change-the-date/shop' },
  [CARD_TYPE_MAP.enclosure]: { name: 'Enclosure cards', url: '/wedding-planning/enclosures/shop' },
  [CARD_TYPE_MAP.menu]: { name: 'Menus', url: '/wedding-planning/menus/shop' },
  [CARD_TYPE_MAP.program]: { name: 'Programs', url: '/wedding-planning/programs/shop' },
  [CARD_TYPE_MAP.holiday]: { name: 'Holiday cards', url: '/wedding-planning/holiday-cards/shop' },
  [CARD_TYPE_MAP.thankyou]: {
    name: 'Thanks you cards',
    url: '/wedding-planning/thank-you-cards/shop',
  },
  [CARD_TYPE_MAP.place]: { name: 'Place cards', url: '/wedding-planning/place-cards/shop' },
  [CARD_TYPE_MAP.tableNumber]: {
    name: 'Table numbers',
    url: '/wedding-planning/table-numbers/shop',
  },
  [CARD_TYPE_MAP.weddingShower]: {
    name: 'Shower invitations',
    url: '/wedding-planning/bridal-shower/shop',
  },
  [CARD_TYPE_MAP.paperAddOns]: {
    name: 'Paper add-ons',
    url: '/wedding-planning/paper-add-ons/shop',
  },
};
